import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalLoading } from 'react-global-loading';
import axios from 'axios';
import { API_URL } from '../../../../../Constant';
import { getToken, getAuthHeaders, hasAuthSession } from '../../../../../utils/authStorage';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import messages from '../../../../../assets/Messages.json';

function ScrutinySheet() {
  const navigate = useNavigate();
  const [header, setHeader] = useState({
    year: '2022-23',
    dslNo: '404936',
    pslNo: '31186',
    stateCode: '09',
    distCode: '09',
  });

  useEffect(() => {
    try {
      const bs = localStorage.getItem('balanceSheetFormData');
      if (bs) {
        const d = JSON.parse(bs);
        setHeader(prev => ({
          ...prev,
          year: d.year || prev.year,
          dslNo: d.dslNo || prev.dslNo,
          pslNo: d.pslNo || prev.pslNo,
          stateCode: d.state || prev.stateCode || '09',
          distCode: d.district || prev.distCode || '09',
        }));
      }
    } catch (e) {}
  }, []);
  const [inputItemsData, setInputItemsData] = useState([
    {
      slNo: 1,
      blockNo: 'H',
      items: 'Input item (Indigenous)',
      unit: 'X',
      avgRate: 'X',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '1) Woven chenille fabrics of MMF for drapery',
      unit: 'Metre',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '2)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '3)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '4)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '5)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '6)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '7)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '8)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '9)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '10)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '11) Electricity Purchased and Consumed',
      unit: 'KWH',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '12) Coal Consumed',
      unit: 'Tonne',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: 2,
      blockNo: 'I',
      items: 'Directly imported items consumed (Major five items)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '1)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '2)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    },
    {
      slNo: '',
      blockNo: '',
      items: '3)',
      unit: '',
      avgRate: '',
      supdt: '',
      srSupdt: ''
    }
  ]);

  const getAuthConfig = () => {
    if (!hasAuthSession()) return null;
    return getAuthHeaders();
  };

  const blockInfo = useMemo(() => {
    const bs = localStorage.getItem('balanceSheetFormData');
    if (!bs) return { dslNo: '', surveyYear: '' };
    const d = JSON.parse(bs);
    return { dslNo: d.dslNo || '', surveyYear: (d.year || '').split('-')[0] || '' };
  }, []);

  useEffect(() => {
    const fetchInputItems = async () => {
      if (!blockInfo.dslNo || !blockInfo.surveyYear) return;
      try {
        const config = getAuthConfig();
        if (!config) return;
        const payload = { dsl_no: blockInfo.dslNo, survey_year: blockInfo.surveyYear };
        const resp = await axios.post(`${API_URL}api/input-items-indigenous/getInputItemsHAndI`, payload, config);
        const api = resp?.data;
        if (api && api.status && Array.isArray(api.data)) {
          const safe = (v) => v === null || v === undefined ? '' : String(v);
          const h = [];
          const i = [];
          api.data.forEach((row) => {
            const block = safe(row.block_no || row.block || '').toUpperCase();
            const itemRow = {
              slNo: '',
              blockNo: '',
              items: `${safe(row.sl_no || '') ? safe(row.sl_no) + ')' : ''} ${safe(row.item_desc)}`.trim(),
              unit: (() => { const u = safe(row.unit_of_qty); return u === '0' ? '' : u; })(),
              avgRate: safe(row.average_rate_per_unit),
              supdt: '',
              srSupdt: ''
            };
            if (block === 'I') i.push(itemRow); else h.push(itemRow);
          });

          const finalRows = [];
          if (h.length) {
            finalRows.push({ slNo: 1, blockNo: 'H', items: 'Input item (Indigenous)', unit: '', avgRate: '', supdt: '', srSupdt: '' });
            finalRows.push(...h);
          }
          if (i.length) {
            finalRows.push({ slNo: 2, blockNo: 'I', items: 'Directly imported items consumed (Major five items)', unit: '', avgRate: '', supdt: '', srSupdt: '' });
            finalRows.push(...i);
          }

          if (finalRows.length) setInputItemsData(finalRows);
        }
      } catch (error) {
        console.error('Failed to load Input Items H & I:', error);
        toast.error('Failed to load input items data.', messages.COLOR_RED);
      }
    };
    fetchInputItems();
  }, [blockInfo]);

  const [financialMetricsData, setFinancialMetricsData] = useState([
    { item: '1) Average Salary/Wages per manday worked (Rs.) (BI E item 5, col.8 / item 5, col.5)', currentYear: '', previousYear: '', reasons: '' },
    { item: '2) Total Workers (BI E, item 5, col.6)', currentYear: '', previousYear: '', reasons: '' },
    { item: '3) Total Employees (BI E, item 9, col.6)', currentYear: '', previousYear: '', reasons: '' },
    { item: '4) Total Emoluments {BI E, item (9+10+11+12), col.8}', currentYear: '', previousYear: '', reasons: '' },
    { item: '5) Variation in Finished Goods {BI D, item 6, (col.4 - col.3)}', currentYear: '', previousYear: '', reasons: '' },
    { item: '6) Working Capital (BI D, item 16, col.4)', currentYear: '', previousYear: '', reasons: '' },
    { item: '7) Total Input : {BI F, item (1+2(i)+2(ii)+3+4+6+7+8+11), col.3 + BI H, item 23, col.6, + BI I, item 7, col.6}', currentYear: '', previousYear: '', reasons: '' },
    { item: '8) Total Output: {BI J, item 12, col.(7-8-9-10+11) + BI D, item 6 (col.4 - col.3) + BI G, item (1+2+3+4+6+7+8+11), col.3 + BI F, item 7, col.3}', currentYear: '', previousYear: '', reasons: '' },
    { item: '9) Gross Value Added (Item 8 - Item 7) as above', currentYear: '', previousYear: '', reasons: '' },
    { item: '10) Net Value Added (Item 9 as above) - Depreciation (BI C, item 10, Col.9)', currentYear: '', previousYear: '', reasons: '' },
    { item: '11) Net Income (Item 10 as above) - {BI F, items (9+10), col.3}', currentYear: '', previousYear: '', reasons: '' },
    { item: '12) Profit (Item 11 as above) - {BI E, items (9+10+11+12), Col.8}', currentYear: '', previousYear: '', reasons: '' },
    { item: '13) Actual addition to Fixed Assets (BI C, item 10, Col.5)', currentYear: '', previousYear: '', reasons: '' },
    { item: '14) G V A (through Ex-factory value): (BI J, item 12, col.13) + BI G, item (1+2+3+4+6+7+8+11), col.3 + BI F, item 7, col.3 - (item 7 as above)', currentYear: '', previousYear: '', reasons: '' }
  ]);

  // Fetch Financial and Operational Metrics
  useEffect(() => {
    const fetchMetrics = async () => {
      if (!blockInfo.dslNo || !blockInfo.surveyYear) return;
      try {
        const config = getAuthConfig();
        if (!config) return;
        const payload = { dsl_no: blockInfo.dslNo, survey_year: blockInfo.surveyYear };
        const resp = await axios.post(`${API_URL}api/blockd/multiple-block-calculation`, payload, config);
        const api = resp?.data;
        if (api && api.status && api.data) {
          const safe = (v) => (v === null || v === undefined ? '' : String(v));
          const calc = Array.isArray(api.data.calculations) ? api.data.calculations : [];
          if (calc.length) {
            const byNumber = {};
            calc.forEach(c => { byNumber[safe(c.item_number)] = c; });
            setFinancialMetricsData(prev => prev.map((row, idx) => {
              const key = String(idx + 1);
              const c = byNumber[key];
              if (!c) return row;
              return {
                ...row,
                currentYear: safe(c.current_year),
                previousYear: safe(c.previous_year),
                reasons: safe(c.reasons_for_variation)
              };
            }));
          }
        }
      } catch (error) {
        console.error('Failed to load multiple-block-calculation:', error);
        // silent fail as this is report; can enable toast if needed
      }
    };
    fetchMetrics();
  }, [blockInfo]);

  const checkPointsPartA = [
    'Whether codes and identification particulars have been correctly furnished in Block A?',
    'Whether information for all the items in Block B have been correctly furnished ?',
    'Whether the entries against item 4 & 5 in Block B are furnished ?',
    'Whether the return has been duly signed by Owner with stamp ?',
    'If the Working Capital in item 16 of Block D is negative whether reasons furnished in the footnote of Block-D of the Return and also in Block N along with code.',
    'If wide variation is noticed between Opening & Closing values of Working Capital, whether reasons furnished in the footnote of Block D and also in Block N along with code.',
    'Whether special check has been made in case of negative GVA ?',
    'Whether basic entries have been thoroughly rechecked where output/input ratio is less than 0.5',
    'Whether ratio of Distributive Expenses to Gross Sales is reasonable ? If no, whether the relevant entries have been rechecked particularly where this ratio exceeds 20%',
    'If the total Bonus is more than 20% of total Wages/Salaries whether suitable remarks given in the Return?',
    'If sale value of goods sold in same condition as purchased (Item-11 of Block-G) is less than the purchase value of the same (Item-11 of Block-F), whether reasons furnished in the return ?',
    'Whether Balance Sheet, Profit & Loss Account and Working Sheet are attached with the O/c of the Return?',
    'Whether, the ex-factory value of output in column-13 of Block-J have been calculated correctly for each of the 10 major items of products and by-products and also for item 11 ?',
    'Whether, the entries in Block-H and I are reported independently?'
  ];

  const checkPointsPartB = [
    'Examine the Industry Code with reference to Production/Process and state whether Industry Code (NIC 2008) is reported in 5 digit NIC 2008 against item 5 of Block \'A\'',
    'Whether valid new State Code has been entered against item 7 of Block \'A\'',
    'Whether Schedule Despatch No. has been correctly filled in against item 1 of Block A?',
    'State whether proper remarks in Block N for all important parameters such as GVA, working capital, wage rate, number of workers, distributive expenses, depreciation etc. are given.',
    'Whether average salaries/wages per manday worked (worker) has been checked calculated correctly and are within the reasonable limits?',
    'Whether special check has been made in case of negative GVA ?',
    'Whether basic entries have been rechecked where Output/Input ratio is less than 0.5',
    'Whether ratio of Distributive Expenses to Gross Sales is reasonable ? If no, whether the relevant entries have been rechecked particularly where this ratio exceeds 20%',
    'If total Bonus exceeds 20% of total Salaries & Wages, whether suitable remarks furnished ?',
    'Whether yield ratio of products from Basic Materials Consumed (in case the units of quantity are common or directly convertible) are correctly calculated and are within prescribed limits. ?',
    'Whether data reported in the return have been checked with Balance Sheet and Profit & Loss Account?',
    'Remarks'
  ];

  return (
    <>
      <style>
        {`
          .report-container { background-color:#fff; border:1px solid #ddd; border-radius:6px; padding:20px; margin-bottom:20px; }
          .report-title { color:#333; font-size:18px; font-weight:bold; padding:15px 20px; margin:-20px -20px 20px -20px; border-radius:6px 6px 0 0; border-bottom:2px solid #333; text-align:center; }
          .report-info { background:#f8f9fa; padding:10px 15px; margin-bottom:20px; border-radius:4px; border-left:4px solid #333; }
          .scrutiny-container {
            background-color: #fff;
            padding: 20px;
          }
          .scrutiny-header-v2{ text-align:center; margin-bottom:10px; }
          .asi-title{ font-size:26px; font-weight:800; color:#1d4f91; }
          .asi-year{ font-weight:800; margin-left:8px; font-size:26px; color:#1d4f91; }
          .report-sub{ font-size:18px; color:#1d4f91; margin-top:6px; }
          .id-row{ display:flex; gap:32px; align-items:center; justify-content:flex-start; margin:14px 0 8px; }
          .id-cell{ font-size:14px; color:#333; }
          .id-value{ color:#1d4f91; text-decoration: underline; font-weight:600; margin-left:8px; }
          .scrutiny-header {
            text-align: center;
            margin-bottom: 20px;
          }
          .scrutiny-title {
            font-size: 24px;
            font-weight: bold;
            color: #1976d2;
            margin-bottom: 5px;
          }
          .scrutiny-subtitle {
            font-size: 18px;
            color: #1976d2;
            margin-bottom: 15px;
          }
          .identification-section {
            background-color: #f8f9fa;
            padding: 15px;
            border-radius: 6px;
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 10px;
          }
          .id-item {
            font-size: 12px;
            color: #333;
          }
          .input-items-section {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 20px;
            margin-bottom: 20px;
          }
          .section-title {
            font-weight: bold;
            color: #1976d2;
            margin-bottom: 15px;
            font-size: 16px;
          }
          .input-items-table {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
          }
          .table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: 600;
            font-size: 10px;
            text-align: center;
            vertical-align: middle;
            padding: 8px 4px;
            border: 1px solid #dee2e6;
          }
          .table td {
            font-size: 10px;
            text-align: center;
            vertical-align: middle;
            padding: 6px 4px;
            border: 1px solid #dee2e6;
          }
          .table td:nth-child(3) {
            text-align: left;
            font-weight: 500;
          }
          .financial-metrics-section {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 20px;
            margin-bottom: 20px;
          }
          .financial-table {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
          }
          .financial-table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: 600;
            font-size: 10px;
            text-align: center;
            vertical-align: middle;
            padding: 8px 4px;
            border: 1px solid #dee2e6;
          }
          .financial-table td {
            font-size: 10px;
            text-align: center;
            vertical-align: middle;
            padding: 6px 4px;
            border: 1px solid #dee2e6;
          }
          .financial-table td:nth-child(3){ text-align:center !important; }
          .financial-table td:first-child {
            text-align: left;
            font-weight: 500;
            min-width: 300px;
          }
          .check-points-section {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 20px;
            margin-bottom: 20px;
          }
          .check-points-table {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
          }
          .check-points-table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: 600;
            font-size: 11px;
            text-align: center;
            vertical-align: middle;
            padding: 8px 4px;
            border: 1px solid #dee2e6;
          }
          .check-points-table td {
            font-size: 11px;
            text-align: left;
            vertical-align: middle;
            padding: 8px 4px;
            border: 1px solid #dee2e6;
          }
          .check-points-table td:first-child {
            width: 80%;
          }
          .check-points-table td:last-child {
            width: 20%;
            text-align: center;
          }
          .read-box { display:block; width:100%; height:28px; border:1px solid #dee2e6; border-radius:2px; background:#fff; }
          .signature-section {
            margin-top: 20px;
            padding-top: 15px;
            border-top: 1px solid #ddd;
          }
          .signature-row{ display:flex; align-items:flex-end; justify-content:space-between; gap:24px; }
          .signature-col{ flex:1; }
          .signature-label { font-weight:600; color:#333; margin-bottom:6px; display:block; }
          .signature-line-field{ display:block; width:100%; height:28px; border-bottom:1px solid #333; }
          .signature-space{ display:block; width:100%; min-height:48px; margin-top:6px; }
          .notes-section {
            background-color: #f8f9fa;
            padding: 15px;
            border-radius: 4px;
            margin-bottom: 20px;
            font-size: 12px;
            color: #666;
            border-left: 4px solid #1976d2;
          }
          .percentage-section {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 15px;
            margin-bottom: 20px;
          }
          .percentage-row{ display:flex; align-items:center; justify-content:space-between; gap:16px; }
          .percentage-label{ font-weight:600; color:#1976d2; font-size:14px; }
          .percentage-input{ width: 160px; }
          .input-group-text{ font-size:12px; }
          .read-box-perc{ display:inline-flex; align-items:center; justify-content:center; width:34px; height:32px; border:1px solid #dee2e6; border-radius:2px; background:#fff; font-size:12px; }
          @media print { .no-print{display:none!important;} .report-container{border:none;margin:0;padding:0;} .report-title{margin:0;border-radius:0;} }
        `}
      </style>
      <div className="container-fluid py-3">
        <GlobalLoading />
        <div className="report-container">
      <div className="scrutiny-container">
        {/* Header */}
        <div className="scrutiny-header-v2">
          <div>
            <span className="asi-title">Annual Survey of Industries</span>
            <span className="asi-year">{header.year}</span>
          </div>
          <div className="report-sub">Report of Scrutiny on Part-I of the Return</div>
        </div>

        {/* Identification Section */}
        <div className="identification-section">
          <div className="id-item">State Code <span className="id-value">{header.stateCode}</span></div>
          <div className="id-item">Distt.(code) <span className="id-value">{header.distCode}</span></div>
          <div className="id-item">DSL No <span className="id-value">{header.dslNo}</span></div>
          <div className="id-item">PSL No <span className="id-value">{header.pslNo}</span></div>
          <div className="id-item">Scheme Code 2</div>
        </div>

        {/* Input Items Section */}
        <div className="input-items-section">
          <div className="section-title">Input Items Scrutiny</div>
          <div className="input-items-table">
            <div className="table-responsive">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Sl No</th>
                    <th>B/no</th>
                    <th>Items</th>
                    <th>Unit</th>
                    <th>Average rate per unit*</th>
                    <th colSpan="2">If high or low, reasons to be furnished by</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>Supdt.</th>
                    <th>Sr. Supdt.</th>
                  </tr>
                </thead>
                <tbody>
                  {inputItemsData.map((row, index) => (
                    <tr key={index}>
                      <td>{row.slNo}</td>
                      <td>{row.blockNo}</td>
                      <td>{row.items}</td>
                      <td>{row.unit}</td>
                      <td>{row.avgRate}</td>
                      <td>{row.supdt}</td>
                      <td>{row.srSupdt}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="notes-section">
            *Average Value per unit in nearest whole rupees to be reported.
          </div>
        </div>

        {/* Percentage Yield Section */}
        <div className="percentage-section">
          <div className="percentage-row">
            <div className="percentage-label">3. Percentage yield of product from the basic materials consumed (in case the quantity are common or directly convertible in whole number)</div>
            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span className="read-box" style={{ width:'160px' }} />
              <span className="read-box-perc">%</span>
            </div>
          </div>
        </div>

        {/* Financial Metrics Section */}
        <div className="financial-metrics-section">
          <div className="section-title">4. Financial and Operational Metrics</div>
          <div className="financial-table">
            <div className="table-responsive">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Current Year</th>
                    <th>Previous Year</th>
                    <th>Reasons for significant Variation, if any</th>
                  </tr>
                </thead>
                <tbody>
                  {financialMetricsData.map((row, index) => (
                    <tr key={index}>
                      <td>{row.item}</td>
                      <td>{row.currentYear}</td>
                      <td>{row.previousYear}</td>
                      <td>{row.reasons}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Check Points Part A */}
        <div className="check-points-section">
          <div className="section-title">5. Impose check on the following and give observations against each item</div>
          <div className="check-points-table">
            <div className="table-responsive">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Check Points</th>
                    <th>Observation (Yes/No)</th>
                  </tr>
                </thead>
                <tbody>
                  {checkPointsPartA.map((point, index) => (
                    <tr key={index}>
                      <td>{index + 1}. {point}</td>
                      <td><span className="read-box" /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="signature-section">
            <div className="signature-row">
              <div className="signature-col">
                <span className="signature-label">Name of the Supdt./Sr.Supdt.:</span>
                <span className="signature-space" />
              </div>
              <div className="signature-col" style={{ textAlign:'right' }}>
                <span className="signature-label">Signature of the Supdt./Sr.Supdt.:</span>
                <span className="signature-space" />
              </div>
            </div>
          </div>
        </div>

        {/* Check Points Part B */}
        <div className="check-points-section">
          <div className="section-title">PART - B (To be filled in by Scrutinizing officer)</div>
          <div className="section-title">Impose check on the following and give observations against each item</div>
          <div className="check-points-table">
            <div className="table-responsive">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Check points</th>
                    <th>Observation (Yes/No)</th>
                  </tr>
                </thead>
                <tbody>
                  {checkPointsPartB.map((point, index) => (
                    <tr key={index}>
                      <td>{index + 1}. {point}</td>
                      <td><span className="read-box" /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="signature-section">
            <div className="signature-row">
              <div className="signature-col">
                <span className="signature-label">Name of the Supdt./Sr.Supdt.:</span>
                <span className="signature-space" />
              </div>
              <div className="signature-col" style={{ textAlign:'right' }}>
                <span className="signature-label">Signature of the Supdt./Sr.Supdt.:</span>
                <span className="signature-space" />
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        </div>
        <div className="row no-print mt-4">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button type="button" className="btn btn_orange mx-1" onClick={() => window.print()}>
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            <button type="button" className="btn btn_orange mx-1" onClick={() => navigate('/report-selection')}>Cancel</button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button type="button" className="btn btn_orange mx-1" onClick={() => navigate(-1)}>
              Back 
              <i className="fa fa-angle-left ms-1"></i>
            </button>
          </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default ScrutinySheet; 